import { AxiosError } from 'axios';
import { axiosClient } from '@nx-frontend/shared/api';
import { AppAccessDeniedError, IAccessDeniedError, TaskResponseDto } from '@nx-frontend/shared/types';
import { MoveNotePayload } from '@nx-frontend/shared/types';

type ClientMoveNotePayload = Pick<
  MoveNotePayload,
  | 'workspaceFrom'
  | 'noteFrom'
  | 'workspaceId'
  | 'remove'
  | 'parentId'
  | 'titleSuffix'
  | 'duplicating'
  | 'taskId'
  | 'cnt'
  | 'notIncludePortalShare'
>;

export async function clientMoveNote({
  workspaceFrom,
  noteFrom,
  workspaceId,
  remove,
  parentId,
  titleSuffix,
  duplicating,
  taskId,
  cnt,
  notIncludePortalShare,
}: ClientMoveNotePayload): Promise<TaskResponseDto | null> {
  try {
    const response = await axiosClient.post<TaskResponseDto>(
      `/v2/api/workspaces/${workspaceFrom}/notes/${noteFrom}/move`,
      {
        workspaceId,
        remove,
        parentId,
        titleSuffix,
        duplicating,
        taskId,
        cnt,
        notIncludePortalShare,
      }
    );
    return response.data;
  } catch (err) {
    if (err instanceof AxiosError) {
      if (err.response?.data?.error?.name === 'AccessDenied') {
        // construct access denied error
        const data = err.response?.data.error as IAccessDeniedError;
        throw new AppAccessDeniedError(data);
      }
    }
    console.log(`moveNote error: ${err}`);
  }
  return null;
}
